import React, {useState} from 'react';
import Headroom from 'react-headroom';
import GlobalNavigation from './GlobalNavigation';

type Props = {
  appStoreUrl: string;
  currentPath: string;
  googlePlayUrl: string;
};

/**
 * GlobalHeader
 *
 * @return {ReactElement}
 */
export default function GlobalHeader({
  appStoreUrl,
  currentPath,
  googlePlayUrl,
}: Props) {
  const [fixed, setFixed] = useState<boolean>(false);
  return (
    <Headroom onUnfix={() => setFixed(true)} onUnpin={() => setFixed(false)}>
      <div className="GlobalHeader">
        <h1 className="GlobalHeader_logo">
          <a className="GlobalHeader_logo_anchor" href="https://vandle.jp/">
            <img
              alt="バンドルカード"
              className="GlobalHeader_logo_mark"
              src="/images/logo/vandle_logo_normal.png"
            />
          </a>
        </h1>
        <GlobalNavigation
          appStoreUrl={appStoreUrl}
          currentPath={currentPath}
          fixed={fixed}
          googlePlayUrl={googlePlayUrl}
        />
      </div>
    </Headroom>
  );
}
